import {isEqual} from "underscore";
import {Button, Col, Row} from "antd";
import {CloseOutlined} from "@ant-design/icons";
import {formatNumber} from "@lib/format";
import React, {useMemo} from "react";
import {SCREEN, useWindowSize} from "@components/window-size-provider";

interface ClearFiltersBarParams {
    className?: string,
    defaultFilters: any;
    filters: any;
    issueCount?: number | null;
    onClear: () => void;
}

export const checkFiltersMatch = (defaultFilters, testFilters) => {
    const defaultNoSort = {...defaultFilters, sort: undefined};
    const filtersNoSort = {...testFilters, sort: undefined};
    return isEqual(defaultNoSort, filtersNoSort);
};

const ClearFiltersBar = ({defaultFilters, filters, issueCount, onClear, className}: ClearFiltersBarParams) => {
    const windowDimensions = useWindowSize();

    const showBar = useMemo(() => {
        return !checkFiltersMatch(defaultFilters, filters);
    }, [defaultFilters, filters]);

    return (
        <>
        {showBar && (
            <Row className={`clear-filters-row ${className}`}>
                <Col span={16} className={'clear-filters-right'}>
                    Filtered items:&nbsp;
                    {issueCount && (<b>{formatNumber(issueCount)}</b>) }
                </Col>
                <Col span={8} className={'clear-filters-left'}>
                    <Button className="filterButton greyButton" size={"large"} onClick={onClear} >
                        <span className="filterButtonText">Clear{windowDimensions.up(SCREEN.SM) && (" Filter")}</span>
                        <CloseOutlined className='font-16' />
                    </Button>
                </Col>
            </Row>
        )}
        </>
    );
};

export default ClearFiltersBar;